export interface StoredSession {
    sessionId: string;
    lastActivityTimestamp: number;
    sessionStartTimestamp: number;
}

/**
 * Session identity is shared across browser tabs via a localStorage blob
 * (matching GA/PostHog). When a tab's in-memory session goes stale, it must
 * adopt the shared session another tab kept alive instead of minting a
 * competitor. A stored session is adoptable when it is a different, still
 * live (not idle-expired, not over max length) session.
 */
export function isAdoptableSharedSession(
    stored: Partial<StoredSession> | null | undefined,
    currentSessionId: string | undefined,
    now: number,
    idleTimeoutMs: number,
    maxLengthMs: number,
): stored is StoredSession {
    return Boolean(
        stored &&
        stored.sessionId &&
        stored.sessionId !== currentSessionId &&
        typeof stored.lastActivityTimestamp === 'number' &&
        typeof stored.sessionStartTimestamp === 'number' &&
        now - stored.lastActivityTimestamp <= idleTimeoutMs &&
        now - stored.sessionStartTimestamp <= maxLengthMs,
    );
}
